import React from 'react'


const Home = () => {
  return (
    <div className='mainContainer'>
      <div className='avatar'>
        <img src="/images/profile.jpg" alt="avatar" className='avatarImg' />
      </div>
      <div className='maincontent'>
        <div className='maincontentHeader'>
          <p>Hey, I am</p>
          <p className='intro-name'>PRAKASH SUBBA</p>
          <p>I am a Software Engineer who specializes in <br></br>Frontend and Backend technologies</p>
        </div>
        <div className='maincontentButtons'>
          <a href='/contact' className="button">Contact</a>
          <a href='/portfolio' className="button">Portfolio</a>
        </div>
      </div>
    </div>
  )
}

export default Home

